/* eslint-disable */
import * as THREE from '../../../libs/three.js/build/three.module.js';

/**
 * Model danych pojedynczej panoramy 360°
 */
export class Image360 {
  constructor(
    file,
    time,
    longitude,
    latitude,
    altitude,
    course,
    pitch,
    roll,
    real,
    type,
    isHidden
  ) {
    this.file = file;
    this.time = time;
    this.longitude = longitude;
    this.latitude = latitude;
    this.altitude = altitude;
    this.type = type;
    this.floor = undefined;
    
    // Jeśli 'real' (quaternion w) jest podany, konwertuj quaternion na kąty Eulera
    if (real) {
      let quaternion = new THREE.Quaternion(roll, pitch, course, real);
      this.quaternion = quaternion.normalize();
      let euler = new THREE.Euler(0, 0, 0, 'YXZ').setFromQuaternion(quaternion);
      
      // Leica ma inny offset kursu niż pozostałe formaty
      if (type === 'leica') {
        this.course = THREE.MathUtils.radToDeg(euler._z) - 180;
      } else {
        this.course = THREE.MathUtils.radToDeg(euler._z) - 90;
      }
      this.pitch = THREE.MathUtils.radToDeg(euler._y);
      this.roll = THREE.MathUtils.radToDeg(euler._x);
    } else {
      this.course = course;
      this.pitch = pitch;
      this.roll = roll;
    }
    
    this.mesh = null;
    this.position = null;
    this.name = null;
    this.texture = null;
    
    if (isHidden === null || isHidden === undefined) {
      this.isHidden = false;
    } else {
      this.isHidden = isHidden;
    }
    
    this.toDelete = false;
    this.layer = null;
  }
}

